<template>
  <div :class="'populatedForm'+(checkMobile() === false?' formInline':'')" @keyup.enter.prevent.stop="keyEnterCB" >
    <div v-if="collapseStyle!== undefined||formTitle" class="col-md-12 formHeader">
      <span class="formTitle">{{formTitle}}</span>
      <div class="float-right mr-2">
        <font-awesome-icon class="filterOnIcon optionClose" @click.prevent="showFilter = !showFilter" v-show="showFilter===true&&collapseStyle!== undefined" :icon="['fas','toggle-on']" v-b-tooltip.hover title="隱藏篩選條件"/>
        <font-awesome-icon class="filterOnIcon optionOpen" @click.prevent="showFilter = !showFilter" v-show="showFilter===false&&collapseStyle!== undefined" :icon="['fas','toggle-off']" v-b-tooltip.hover title="打開篩選條件"/>
        <div v-show="collapseStyle=== undefined" class="filterOnIcon"></div>
      </div>
    </div>
    <b-alert
      dismissible
      fade
      variant="danger"
      :show="dismissCountDown"
      @dismissed="dismissCountDown=0"
      class="col-md-10 m-1">
      <span v-html="AlertPrompt"></span>
    </b-alert>
    <!--
      這裡狂傳prop與event,是依賴多傳不會死的特性來泛用(= =)
      裡面不能寫註解...所以只好寫上面

      label是上方的label(不支持左邊,太複雜)
      要配label時,要不是全配,就是全部不要配
      同一列的組件若有label與沒label則高度會無法對齊

    -->
    <field-container
      v-show="showFilter===true"
      v-for="option in populateOptions"
      :key="option.akey"
      :fkey="fkey"
      :componentType="option.componentType"
      :formDataObj="formDataObj"
      
      :validatePrompt="validatePrompt"
      :validatePromptHint="option.validatePromptHint"
      :isRequired="option.isRequired?true:false"
      :customValidateCB="option.customValidateCB"

      :class="'col-md-'+(option.col?option.col:'6')"
      :title="option.title?option.title:''"
      :placeholder="option.placeholder?option.placeholder:''"
      :defaultValue="option.defaultValue?option.defaultValue:null"
      :label="option.label?option.label:''"
      :rows="option.rows"
      :max="option.max?option.max:undefined"
      :min="option.min?option.min:undefined"

      :disabled="option.disabled?true:false"
      :hide="option.hide?option.hide:undefined"
      :centerText="option.centerText?true:undefined"

      :selectOptions="getOptions(option)"
      :customSelectObject="customSelectObject(option)"

      :groupStacked="option.groupStacked?true:false"

      :minuteInterval="option.minuteInterval?option.minuteInterval:undefined"
      :timeFormat="option.timeFormat?option.timeFormat:undefined"
      :minHour="option.minHour?option.minHour:undefined"
      :maxHour="option.maxHour?option.maxHour:undefined"

      :option-label="option.optionLabel"
      :optionVar="option.optionVar"
      :akey="option.akey"
      @customValueChanged="customValueChanged"
      :asyncDelayMS="option.asyncMS?option.asyncMS:750"
      :asyncFetchCB="option.asyncFetchCB"
      :asyncFetch="option.asyncFetchCB!==undefined"
      
      :starSize="option.starSize?option.starSize:undefined"
      :showRating="option.showRating?option.showRating:undefined"
      :maxRating="option.maxRating?option.maxRating:undefined"

      :buttons="(option.componentType==='btn-group'&&option.buttons&&option.buttons.length>0?option.buttons:undefined)"
      :btnIcon="(option.componentType==='b-button'&&option.btnIcon)?option.btnIcon:undefined"
      :execCallback="option.execCallback"
      :waitClick="option.waitClick"
      :loc="option.loc?option.loc:undefined"
      :datePickerConfig="getDatePickerConfig(option)"
    ></field-container>
  </div>
</template>

<script>

import FieldContainer from "./FieldContainer"

export default {
  name: 'PopulateForm',
  components: {
    FieldContainer
  },
  data: function () {
    return {
      showFilter:true,
      parentRef: this.$parent,
      dismissSecs: 5,
      dismissCountDown: 0,
      AlertPrompt: String,
    }
  },
  props: {
    'formTitle':String,
    // form key,與akey組動態子篩選組件的dom id
    'fkey':String,
    // 是否提供收縮選項
    'collapseStyle':String,
    // parent對應此form的控制項設定陣列var array name(動態pass)
    'populateOptionVar':String,
    // 是否啟用輸入警告(為求排版整齊,只有全部開或全部不開)
    'validatePrompt':Boolean,
    // parent對應此form的model data obj name
    'formDataObjVar':String,
    // 要通過這個ref來抓取引用此組件的上層組件的data(可能跨一層以上不能寫死用parent)
    'parentVue':Object,
    // form上按enter如需要指定處理可傳遞function進來(如opoup時enter想自動呼叫執行)
    'keyEnterCB':{
      type:Function,
      default: function () {
        return
      }
    },
  },
  methods: {
    triggerAlert(msg) {
      // msg could be html tag
      this.dismissCountDown = this.dismissSecs
      this.AlertPrompt = msg
    },
    skipSubmit(evt) {
      // 因為是用b-form包的,也是form,當組件有階層時容易誤觸送出而reload
      // 此處只是借用b-form做style,一律不做form submit,故一律封掉(一律用ajax api呼叫)
      evt.preventDefault()
      evt.stopPropagation()
    },
    // 只是為了讓介面泛用並提供日期選擇組件預設格式
    getDatePickerConfig(option) {
      if (option.componentType === 'date-picker') {
        if (option.datePickerConfig) {
          return option.datePickerConfig
        }
        else {
          // 沒設定時要給default value
          return {'format':'YYYY-MM-DD','useCurrent':false}
        }
      }
      else {
        return undefined
      }
    },
    initDefault() {
      // 用options內的defailt值初始化obj
      for (let i=0;i<this.populateOptions.length;i++) {
        if (this.populateOptions[i].akey !== undefined) {
          this.formDataObj[this.populateOptions[i].akey] = this.populateOptions[i].defaultValue?this.populateOptions[i].defaultValue:''
        }
      }
      this.refreshModelVar()
      // 更新成功但default值更新後需rerender
      // 因為組件方法只能在mounted後才能呼叫
      // default value用來render,完成後才會mounted
      // 所以事後更新default value UI會是沒吃到預設值的狀態
      // 在父組件created裡寫同一個迴圈用option設定loop obj的default屬性最有效率
      // 提供這個較低效但簡單的方法...在父組件若能宣告時就把default值設定完成就不需呼叫
      // 求開發簡單的話父組件FormDataObj則只需空物件並在mounted呼叫此方法,只要設定好options設定即可
      // 若沒有初始化好此動態展開表單的model 物件的屬性,沒呼叫此方法會出現undefined ref的錯誤
    },
    // 把populateForm的下拉選項選擇改變事件觸發丟回給主組件
    customValueChanged (upd) {
      // date-picker與select選擇的值修改時要這樣觸發修改
      this.parentRef[this.formDataObjVar][upd.key] = upd.val
      // 仍然emit事件,有需要時可以另外處理(select選項改變時有連動操作需要時)
      this.$emit('customValueChanged', upd)
    },
    setFocus(akey) {
      for (let j=0;j<this.$children.length;j++) {
        if (this.$children[j].akey === akey) {
          this.$children[j].setFocus()
          break
        }
      }
    },
    setDisabled(akey, disabled = true) {
      for (let j=0;j<this.$children.length;j++) {
        if (this.$children[j].akey === akey) {
          this.$children[j].setDisabled(disabled)
          break
        }
      }
    },
    refreshModelVar (targetKeys = '') {
      // 修正子組件的顯示狀態與父model對應物件不一致的問題
      // 傳akey,會重新針對指定的akey的組件把UI的顯示和model數據同步一次
      // 目前只實作select類與input類,radio與checkbox group還沒支援處理
      for (let j=0;j<this.$children.length;j++) {
        const checkValues = targetKeys.split(',')
        // 空的checkValues就是全部
        if (this.$children[j].hide !== true && (checkValues[0] === '' || checkValues.indexOf(this.$children[j].akey) !== -1 )) {
          if ((this.$children[j].componentType === 'b-form-select' || this.$children[j].componentType === 'vue-single-select') && this.$children[j].optionVar && this.parentRef[this.$children[j].optionVar]) {
            if (this.parentRef[this.$children[j].optionVar].length) {
              setTimeout(() => {
                for (let i=0;i<this.parentRef[this.populateOptionVar].length;i++) {
                  if (this.parentRef[this.populateOptionVar][i].akey === this.$children[j].akey) {
                    this.parentRef[this.populateOptionVar][i].selectOptions = this.parentRef[this.$parent[this.populateOptionVar][i].optionVar]
                  }
                }
              }, 100);
            }
            else {
              for (let i=0;i<this.parentRef[this.populateOptionVar].length;i++) {
                if (this.parentRef[this.populateOptionVar][i].akey === this.$children[j].akey) {
                  this.parentRef[this.populateOptionVar][i].selectOptions = this.parentRef[this.parentRef[this.populateOptionVar][i].optionVar]
                }
              }
              this.$children[j].clearSelectLocalValue()
            }
          }
          // date-picker的處理方式和input相同,要補上(否則先設定好formDataObjVar的值後refreshModelVar沒實作的date-picker就會失效)
          else if (this.$bus.formInputTypes.concat(['date-picker']).includes(this.$children[j].componentType)) {
            // datePickerConfig有獨立指定時要refresh
            for (let i=0;i<this.parentRef[this.populateOptionVar].length;i++) {
              if (this.parentRef[this.populateOptionVar][i].akey === this.$children[j].akey && this.parentRef[this.populateOptionVar][i].datePickerConfig) {
                //this.$children[j].config = this.parentRef[this.populateOptionVar][i].datePickerConfig
                this.$children[j].resetDatePickConfig(this.parentRef[this.populateOptionVar][i].datePickerConfig)
                //剛set完datepicker的config會導致後面的set value時好時壞,常常更新不到
                setTimeout(() => {
                  let objdp = this.$children[j].$el.querySelector('input')
                  if (objdp && this.parentRef[this.formDataObjVar][this.$children[j].akey] !== undefined) {
                    objdp.value = this.parentRef[this.formDataObjVar][this.$children[j].akey]
                  }                  
                }, 50);
                break
              }
            }
            let obj = this.$children[j].$el.querySelector('input')
            if (obj && this.parentRef[this.formDataObjVar][this.$children[j].akey] !== undefined) {
              obj.value = this.parentRef[this.formDataObjVar][this.$children[j].akey]
            }
          }
          else if (['b-form-checkbox','b-form-radio-group'].includes(this.$children[j].componentType)) {
            // 剛好是用同樣方法reset
            this.$children[j].setCheckedValue(this.parentRef[this.formDataObjVar][this.$children[j].akey])
          }
          else if (['vue-timepicker'].includes(this.$children[j].componentType)) {
            this.$children[j].setPickTime(this.parentRef[this.formDataObjVar][this.$children[j].akey])
          }
          else if (this.$children[j].componentType === 'span' && this.$children[j].akey && this.parentRef[this.formDataObjVar][this.$children[j].akey] !== undefined) {
            // 讓span類的動態更新顯示值也可以透過refreshModelVar實現不用另外寫
            // 有定義span類的akey且對應的formData[akey]不是undefined時,呼叫時就抓data更新placeholder
            for (let i=0;i<this.parentRef[this.populateOptionVar].length;i++) {
              if (this.parentRef[this.populateOptionVar][i].akey === this.$children[j].akey) {
                this.parentRef[this.populateOptionVar][i].placeholder = this.parentRef[this.formDataObjVar][this.$children[j].akey]+''
              }
            }
          }
          /*else if (['date-picker'].includes(this.$children[j].componentType)) {
            // date-picker
            let obj = this.$children[j].$el.querySelector('input')
            if (obj) {
              obj.value = this.parentRef[this.formDataObjVar][this.$children[j].akey]
            }
          }*/
          //下拉選單的selected值bind
          for (let i=0;i<this.parentRef[this.populateOptionVar].length;i++) {
            if (this.parentRef[this.populateOptionVar][i].akey === this.$children[j].akey && this.parentRef[this.populateOptionVar][i].componentType === 'b-form-select') {
              this.$children[j].setSelectedValue()
            }
          }
        }
      }
    },
    getOptions(option) {
      // 動態的option var優先,再來是寫死的dataOptions,都沒有回傳空陣列給prop
      if (option.optionVar && this.parentRef && this.parentRef[option.optionVar] && this.parentRef[option.optionVar].constructor === Array) {
        return this.parentRef[option.optionVar]
      }
      else if (option.dataOptions && option.dataOptions.constructor === Array) {
        return option.dataOptions
      }
      return undefined
    },
    customSelectObject(option) {
      // 決定一個populateOption是否需要render額外的option(僅兩種下拉選單類型用得到,其他都是false)
      // 動態的b-form-select一律是custom
      if (option && option.componentType === 'b-form-select' && option.optionVar && this.parentRef && this.parentRef[option.optionVar] && this.parentRef[option.optionVar].constructor === Array) {
        return true
      }
      // 非動態的b-form-select,使用的dataOptions非為text/value時也動態產生選項(不直接放options進去render)
      else if (option && option.componentType === 'b-form-select' && option.dataOptions && Object.keys(option.dataOptions[0]).length === 2 ) {
        //let keys = ['value','text']
        let keys = Object.keys(option.dataOptions[0]).sort()
        return keys[0] !=='text' || keys[1] !=='value'
      }
      else {
        // 這個屬性只是控制何時要因object類型的選項動態用optionLabel來render
        // 只有b-form-select有機會用到,但套預設簡單text/value設定時也不需要 
        return false
      }
    }
  },
  computed: {
    // 為了彈性允許一個組件內使用一個以上的populateForm,populateOptions用optionVar動態傳入較不會耦合難改
    populateOptions: {
      cache: false,
      get () {
        return this.parentRef[this.populateOptionVar]
      }
    },
    formDataObj: {
      cache: false,
      get () {
        return this.parentRef[this.formDataObjVar]
      },
      set (val) {
        this.parentRef[this.formDataObjVar] = val
      }
    },
  },
  created () {
    if (this.parentVue !== undefined) {
      this.parentRef = this.parentVue
    }
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.populatedForm {
  background-color: rgb(247, 245, 242);
  padding-bottom: 10px;
  margin-top:1px;
}

.formInline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.formHeader {
  display:inline-block;
  position:relative;
  margin-bottom:5px;
}

.filterOnIcon {
  width:50px;
  height:30px;
  margin-top:5px;
  margin-bottom:-5px;
  
}

.optionOpen {
  cursor:-webkit-zoom-in;
}

.optionClose {
  cursor:-webkit-zoom-out;
}

.formTitle {
  position:absolute;
  top:5px;
  left:20px;
  color: white;
  background-color: darkblue;
  padding-left:30px;
  padding-right:30px;
}

::-webkit-input-placeholder  { /* Chrome */
  color: darkgray;
  opacity: 0.5;
  transition: opacity 250ms ease-in-out;
}

</style>
